import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { AccountGroupService, ProjectionFilter } from '@galaxy/account-group';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, map } from 'rxjs';

interface AccountGroupContext {
  companyName: string;
  address: string;
  address2: string;
  workNumber: string[];
}
@Component({
  selector: 'work-order-context',
  imports: [CommonModule, MatExpansionModule, TranslateModule],
  templateUrl: './work-order-context.component.html',
  styleUrls: ['./work-order-context.component.scss'],
})
export class WorkOrderContextComponent implements OnInit {
  @Input() accountGroupId: string;
  accountGroup$: Observable<AccountGroupContext>;

  constructor(private accountGroupService: AccountGroupService) {}

  ngOnInit(): void {
    this.accountGroup$ = this.accountGroupService
      .get(this.accountGroupId, new ProjectionFilter({ napData: true }))
      .pipe(
        map((business) => {
          return {
            companyName: business?.napData?.companyName,
            address: [business?.napData?.address, business?.napData?.city, business?.napData?.state]
              .filter(Boolean)
              ?.join(', '),
            address2: [business?.napData?.zip, business?.napData?.country].filter(Boolean)?.join(', '),
            workNumber: business?.napData?.workNumber,
          };
        }),
      );
  }
}
